import { Breadcrumb, Button, Card, Col, Empty, Input, message, Modal, Row } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Mutation, Query } from 'react-apollo';
import { Link } from 'react-router-dom';

import { CouponRule, CouponTemplateRuleKey, CouponType, GCouponRule } from '../../types/coupon';
import { GUser } from '../user/Users';

const COUPON_TEMPLATE_QUERY = gql`
  query GetCouponTemplate($ids: [ID]) {
    couponTemplates(ids: $ids) {
      id
      name
      status
      amount
      type
      description
      validDuration
      rules {
        ruleKey
        ruleValue
        skus {
          id
          name
        }
      }
    }
  }
`;

const offerCouponMutation = gql`
  mutation offerCoupon($userId: Int, $couponTemplateName: String) {
    offerCoupon(userId: $userId, couponTemplateName: $couponTemplateName) {
      id
    }
  }
`;

const usersQuery = gql`
  query GetUser($mobile: String) {
    users(mobile: $mobile) {
      id
      name
      mobile
      gender
      region
      avatarUrl
    }
  }
`;

interface Props {
  match: any;
}

interface State {
  mobile: string;
  isOfferCouponPopupConfirmVisible: boolean;
}

export class CouponDetail extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isOfferCouponPopupConfirmVisible: false,
      mobile: '',
    };

    this.onOfferCouponCancelClick = this.onOfferCouponCancelClick.bind(this);
    this.onMobileInput = this.onMobileInput.bind(this);
    this.onReviewOfferCouponClick = this.onReviewOfferCouponClick.bind(this);
  }

  calcDiscountText(type: CouponType, amount: number) {
    switch (type) {
      case CouponType.DISCOUNT:
        return `抵扣${amount * 100}%`;
      case CouponType.DEDUCTION:
        return `抵扣${amount}元`;
    }
    return '-';
  }

  onOfferCouponCancelClick() {
    this.setState({ isOfferCouponPopupConfirmVisible: false });
  }

  getPopupConfirmOfferCoupon(couponTemplateName: string) {
    if (!this.state.isOfferCouponPopupConfirmVisible) {
      return null;
    }
    return (
      <Query query={usersQuery} variables={{ mobile: this.state.mobile }}>
        {({ loading, error, data }) => {
          if (error) return <div>{error.message}</div>;
          if (loading) return <div>loading...</div>;
          if (!data) {
            // @ts-ignore
            return <Empty />;
          }
          const [user] = data.users;

          if (!user) {
            // @ts-ignore
            return <Empty />;
          }

          return this.getPopupOfferCouponQueryAndResult(couponTemplateName, user);
        }}
      </Query>
    );
  }

  calcErrorMessage(errorMessage: string) {
    if (errorMessage.includes('Have already received a coupon')) {
      return '已有优惠券';
    }
    return errorMessage;
  }

  getPopupOfferCouponQueryAndResult(couponTemplateName: string, user: GUser) {
    return (
      <Mutation mutation={offerCouponMutation} variables={{ couponTemplateName, userId: user.id }}>
        {offerCoupon => {
          return (
            <Modal
              width="60%"
              title="确认发券"
              visible={this.state.isOfferCouponPopupConfirmVisible}
              onOk={async () => {
                try {
                  await offerCoupon();
                  this.setState({
                    isOfferCouponPopupConfirmVisible: false,
                  });
                  message.success('发券成功');
                } catch (e) {
                  message.error(this.calcErrorMessage(e.message));
                }
              }}
              onCancel={this.onOfferCouponCancelClick}
            >
              <Card title="用户信息" type="inner">
                <Row gutter={24}>
                  <Col span={6} style={{ textAlign: 'right' }}>
                    ID:
                  </Col>
                  <Col span={6}>{user.id}</Col>
                  <Col span={6} style={{ textAlign: 'right' }}>
                    微信昵称:
                  </Col>
                  <Col span={6}>{user.name}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={6} style={{ textAlign: 'right' }}>
                    手机号:
                  </Col>
                  <Col span={6}>{user.mobile}</Col>
                </Row>
                <Row gutter={24}>
                  <Col span={6} style={{ textAlign: 'right' }}>
                    微信头像:
                  </Col>
                  <Col span={6}>
                    <img src={user.avatarUrl} />
                  </Col>
                </Row>
              </Card>
            </Modal>
          );
        }}
      </Mutation>
    );
  }

  onReviewOfferCouponClick() {
    if (this.state.mobile) {
      this.setState({
        isOfferCouponPopupConfirmVisible: true,
      });
    } else {
      message.info('请输入手机号');
    }
  }

  onMobileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      mobile: e.target.value,
    });
  };

  getSkusLimitList(rules: GCouponRule[]) {
    const skuLimitRule = rules.find(rule => rule.ruleKey === CouponTemplateRuleKey.SKUS_LIMITED);

    if (!skuLimitRule) {
      return '-';
    }
    const { skus = [] } = skuLimitRule;

    let skuListText = '';
    for (const sku of skus) {
      skuListText += `${sku.name},`;
    }

    return skuListText;
  }

  render() {
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/coupon/list`}>优惠券管理</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>优惠券详情</Breadcrumb.Item>
        </Breadcrumb>
        <Query query={COUPON_TEMPLATE_QUERY} variables={{ ids: [this.props.match.params.id] }}>
          {({ loading, error, data }) => {
            if (error) return <div>{error.message}</div>;
            if (loading) return <div>loading...</div>;
            if (!data) {
              // @ts-ignore
              return <Empty />;
            }
            const [couponTemplate] = data.couponTemplates;
            if (!couponTemplate) {
              // @ts-ignore
              return <Empty />;
            }

            const paidUserOnlyRule = couponTemplate.rules.find(
              (item: CouponRule) => item.ruleKey === CouponTemplateRuleKey.PAID_USER_ONLY,
            );

            return (
              <Card title="优惠券详情">
                <Card title="基本信息" type="inner">
                  <Row gutter={24}>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      ID:
                    </Col>
                    <Col span={6}>{couponTemplate.id}</Col>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      优惠券名称:
                    </Col>
                    <Col span={6}>{couponTemplate.name}</Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      优惠券面值:
                    </Col>
                    <Col span={6}>{this.calcDiscountText(couponTemplate.type, Number(couponTemplate.amount))}</Col>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      单个用户可获得数:
                    </Col>
                    <Col span={6}>不限数量</Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      优惠券简介:
                    </Col>
                    <Col span={6}>{couponTemplate.description}</Col>
                  </Row>
                </Card>
                <Card title="使用规则" type="inner">
                  <Row gutter={24}>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      适用课程:
                    </Col>
                    <Col span={6}>{this.getSkusLimitList(couponTemplate.rules)}</Col>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      领用人群:
                    </Col>
                    <Col span={6}>{paidUserOnlyRule ? '付费用户' : '-'}</Col>
                  </Row>
                  <Row gutter={24}>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      有效期:
                    </Col>
                    <Col span={6}>{`领取${moment
                      .duration(couponTemplate.validDuration, 'hours')
                      .humanize()}内有效`}</Col>
                  </Row>
                </Card>
                <Card title="手动发券" type="inner">
                  <Row gutter={24}>
                    <Col span={6} style={{ textAlign: 'right' }}>
                      <Input placeholder="请输入完整手机号" onChange={this.onMobileInput} />
                    </Col>
                    <Col span={6}>
                      <Button type="primary" onClick={this.onReviewOfferCouponClick}>
                        发券
                      </Button>
                    </Col>
                  </Row>
                </Card>

                {this.getPopupConfirmOfferCoupon(couponTemplate.name)}
              </Card>
            );
          }}
        </Query>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/coupon/CouponDetail.tsx